import { Route } from '@angular/router';
import { Path } from '../common/constants/paths.constant';
import { authGuard } from '../common/guards/auth.guard';
import { MainService } from '../common/services/main/main.service';
import { LandingComponent } from '../layout/landing/landing.component';
import { MainComponent } from '../layout/main/main.component';
import { dashboardRoutes } from './dashboard/dashboard.routes';
import { landingRoutes } from './landing/landing.routes';
import { mainRoutes } from './main/main.routes';

export const pagesRoutes: Route[] = [
  {
    path: `:lang`,
    children: [
      {
        path: '',
        component: MainComponent,
        children: [
          ...mainRoutes,
          {
            path: '',
            redirectTo:
              '/' +
              (localStorage.getItem('lang') ?? 'ar') +
              '/' +
              (localStorage.getItem('token') ? Path.DASHBOARD : Path.HOME),
            pathMatch: 'full',
          },
        ],
      },
      {
        path: '',
        component: LandingComponent,
        children: [...landingRoutes],
      },
      {
        path: '',
        providers: [MainService],
        canActivate: [authGuard],
        children: [
          ...dashboardRoutes,
          {
            path: '**',
            redirectTo: `/${localStorage.getItem('lang') ?? 'ar'}/${Path.BUYER}/${Path.DASHBOARD}`,
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'presentation',
        loadComponent: () =>
          import('../pages/presentation/presentation.component').then(
            m => m.PresentationComponent
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo:
      '/' +
      (localStorage.getItem('lang') ?? 'ar') +
      '/' +
      (localStorage.getItem('token') ? Path.DASHBOARD : Path.HOME),
    pathMatch: 'full',
  },
];
